"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
var react_measure_1 = __importDefault(require("react-measure"));
var framer_motion_1 = require("framer-motion");
var styles_2 = require("../styles");
var slider_styles_1 = require("./slider_styles");
var useStyles = styles_1.makeStyles(slider_styles_1.styles);
var Slider = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'primary' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.value, value = _d === void 0 ? 0 : _d, _e = _a.min, min = _e === void 0 ? 0 : _e, _f = _a.max, max = _f === void 0 ? 100 : _f, _g = _a.step, step = _g === void 0 ? 1 : _g, _h = _a.thumbChildren, thumbChildren = _h === void 0 ? null : _h, _j = _a.thumbReference, thumbReference = _j === void 0 ? null : _j, _k = _a.thumbProps, thumbProps = _k === void 0 ? {} : _k, _l = _a.classes, propsClasses = _l === void 0 ? {} : _l, other = __rest(_a, ["color", "disabled", "value", "min", "max", "step", "thumbChildren", "thumbReference", "thumbProps", "classes"]);
    var theme = styles_1.useTheme();
    var classes = useStyles();
    var hexColor = react_1.useMemo(function () { return styles_2.getHexFromTheme(theme, color); }, [theme, color]);
    var _m = react_1.useState(0), containerWidth = _m[0], setContainerWidth = _m[1];
    var handleMeasureChange = react_1.useCallback(function (_a) {
        var width = _a.bounds.width;
        if (width !== containerWidth) {
            setContainerWidth(width);
        }
    }, [containerWidth]);
    console.log({ containerWidth: containerWidth, min: min, max: max, value: value, x: containerWidth * (value / max) });
    return (react_1.default.createElement(react_measure_1.default, { bounds: true, onResize: handleMeasureChange }, function (_a) {
        var measureRef = _a.measureRef;
        return (react_1.default.createElement("div", { ref: measureRef, className: classnames_1.default(classes.container, disabled && classes.disabled, propsClasses.container) },
            react_1.default.createElement("div", { className: classes.track },
                react_1.default.createElement(framer_motion_1.motion.div, { className: classes.rail, animate: {
                        width: containerWidth * (value / (max - min)),
                        color: styles_2.getComponentColor(true, hexColor, disabled),
                    } })),
            react_1.default.createElement(Thumb, __assign({}, { thumbChildren: thumbChildren, classes: classes }, { ref: thumbReference, animate: {
                    x: containerWidth * (value / (max - min)),
                    color: styles_2.getComponentColor(true, hexColor, disabled),
                } }, thumbProps)),
            react_1.default.createElement("input", __assign({ className: classes.input, type: "range" }, { value: value, min: min, max: max, step: step }, other))));
    }));
};
exports.Slider = Slider;
var Thumb = react_1.forwardRef(function (_a, ref) {
    var animate = _a.animate, thumbChildren = _a.thumbChildren, classes = _a.classes, other = __rest(_a, ["animate", "thumbChildren", "classes"]);
    return (react_1.default.createElement(framer_motion_1.motion.div, __assign({ className: classes.thumb }, other, { animate: animate }),
        react_1.default.createElement("div", __assign({ className: classes.thumbChildrenContainer }, { ref: ref }), thumbChildren)));
});
